<template>
    <div id="ProjBidDemandProject">
        <div class="card-header">
            <div class="card-header-left ellipsis">
                {{project.projectName}}
            </div>
            <div class="card-header-right">
                <ebShare/>
            </div>
        </div>
        <div class="card-body">
            <div class="card-body-left">
                <img v-if="project.projectImages" :src="project.projectImages" alt="项目图片">
                <img v-if="!project.projectImages" :src="$ebConfig.imgPath+'img/project-default.jpg'" alt="项目图片">
            </div>
            <div class="card-body-right">
                <div class="card-two-row">
                    <div class="col-243-rw">
                        <div class="col-left">项目编号:</div>
                        <div class="col-right">
                            <span class="col-right-content"> {{project.projectCode}}</span>
                        </div>
                    </div>
                    <div class="col-210-rw">
                        <div class="col-left">采购经办:</div>
                        <div class="col-right">
                            <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="project.buyUserheadImg" :src="buyUserheadSrc">
                            <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="!project.buyUserheadImg" :src="$ebConfig.imgPath+'img/user-default.jpeg'">
                        </div>
                    </div>
                    <div class="col-90-rw ">
                        <span class="font-type-box">
                            <eb-font-type>{{project.projectMethod | projectMethod(true)}}</eb-font-type>
                            <eb-font-type>{{project.projectType | projectType(true)}}</eb-font-type>
                        </span>
                    </div>
                    <div class="col-243-rw">
                        <div class="col-left">发布时间:</div>
                        <div class="col-right">
                            <span class="col-right-content"> {{project.startTime |dateFormatYMDH}}</span>
                        </div>
                    </div>
                </div>
                <div class="card-two-row">
                    <div class="col-243-rw">
                        <div class="col-left">项目预算:</div>
                        <div class="col-right">
                            <span class="col-right-content"> {{project.quoteMin | formatCurrency}}</span>
                        </div>
                    </div>
                    <div class="col-300-rw">
                        <div class="col-left">采购单位:</div>
                        <div class="col-right">
                            <el-tooltip :content="project.buyDepartName ||'-'" placement="top">
                                <span class="col-right-content"> {{project.buyDepartName||'-'}}</span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="col-243-rw">
                        <div class="col-left">截标时间:</div>
                        <div class="col-right">
                            <span class="col-right-content"> {{project.endTime |dateFormatYMDH}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ebFontType from '@/components/common/eb-font-type';
import ebShare from '@/components/common/share/eb-share';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'ProjBidDemandProject',
  props: {
    project: {}
  },
  components: {
    ebShare,
    ebFontType
  },
  methods: {
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    }
  },
  computed: {
    buyUserheadSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.buyUserheadImg + '?time=' + Date.now();
      }
    }
  }
};
</script>
<style scoped lang="less">
#ProjBidDemandProject {
  .card-header {
    display: flex;
  }
  .card-header-left {
    width: 80%;
    height: 52px;
    display: flex;
    color: #060606;
    font-weight: 700;
    font-family: 'Microsoft YaHei';
    align-items: center;
  }
  .card-header-right {
    width: 20%;
    height: 52px;
    display: flex;
    align-items: center;
    line-height: 22px;
    padding-right: 1.3%;
  }
  .card-body {
    display: flex;
  }
  .card-body-left {
    height: 95px;
    width: 14%;
    display: flex;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .card-body-right {
    width: 84%;
    padding-left: 2%;
  }
  .header_img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-top: 8px;
    cursor: pointer;
  }
  .departName {
    cursor: pointer;
    max-width: 93%;
    display: inline-block;
    padding-right: 10px;
  }
}
</style>
